import richTxtZh from './rich-txt-tpl.vue'
import richTxtTw from './rich-txt-tpl-tw.vue'
import richTxtEn from './rich-txt-tpl-en.vue'

export default { richTxtZh, richTxtTw, richTxtEn }
